'use client';

import { useState } from 'react';

import { css } from '@emotion/react';
import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import { Types } from '@scorenco/core';

import { Markdown, Wrapper } from '../../primitives';

type FaqSliceProps = { slice: { children: Types.ComponentSlicesFaq[] } };

export const FaqSlice = ({ slice }: FaqSliceProps) => {
  const [expanded, setExpanded] = useState<number | false>(false);

  const handleChange =
    (panel: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Wrapper marginY={5}>
      <Stack
        mx="auto"
        maxWidth="md"
        justifyContent="stretch"
        alignItems="center"
        gap={3}
      >
        {slice.children.map(({ id, title, content }) => (
          <Accordion
            key={id}
            expanded={expanded === Number(id)}
            onChange={handleChange(Number(id))}
            css={css`
              width: 100%;
            `}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="body1" fontWeight="bold">
                {title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Markdown value={content} />
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </Wrapper>
  );
};
